import { throttle } from "lodash";

const AUDIO_THROTTLE = 8000;

const breakoutAudio = new Audio("/sounds/breakout_cue_05.mp3");
const tickingAudio = new Audio("/sounds/soundfx_final-moments-breakout.mp3");
const timerEndAudio = new Audio("/sounds/timer_notification.mp3");
const notificationAudio = new Audio("/sounds/notification.mp3");
const handRaiseAudio = new Audio("/sounds/soundfx_handraise.mp3");
const testSoundAudio = new Audio("/sounds/test_sound.mp3");

const maybePlayAudio = (audio: HTMLAudioElement) => {
  // May throw an autoplay error if the user hasn't interacted with the page yet
  try {
    audio.play();
  } catch (error) {
    window.flightLogger.warn("Error playing audio", error);
  }
};

export const playBreakoutAudio = () => {
  maybePlayAudio(breakoutAudio);
};

export const playTickingAudio = () => {
  maybePlayAudio(tickingAudio);
};

export const stopTickingAudio = () => {
  tickingAudio.pause();
  tickingAudio.currentTime = 0;
};

export const playTimerEndAudio = () => {
  maybePlayAudio(timerEndAudio);
};

export const playNotificationAudio = throttle(
  () => {
    maybePlayAudio(notificationAudio);
  },
  AUDIO_THROTTLE,
  { trailing: false },
);

export const playHandRaiseAudio = throttle(
  () => {
    maybePlayAudio(handRaiseAudio);
  },
  AUDIO_THROTTLE,
  { trailing: false },
);

export const playTestSoundAudio = () => {
  maybePlayAudio(testSoundAudio);
};
